import { Permission, UserType } from '@/models/user';
import { useAuthentication } from '@/hooks/useAuthentication';
import { useCallback, useMemo } from 'react';

const comparePermissions = (
    permissionsHolding: Permission[] = [],
    permissionsRequired: Permission[] = []
) => {
    if (
        !permissionsRequired.length ||
        permissionsHolding.includes(Permission.ADMIN)
    )
        return true;

    if (!permissionsHolding.length && permissionsRequired.length) return false;

    return permissionsRequired.some((permission) => {
        return permissionsHolding.includes(permission);
    });
};

type UserIsAuthorized = [
    isAuthorized: boolean,
    options: {
        checkPermissions: (permissionsNeeded: Permission[]) => boolean;
    },
];

export const useIsAuthorized = (
    permissionsRequired: Permission[]
): UserIsAuthorized => {
    const { permissions, userType } = useAuthentication();
    const isAuthorized = useMemo(
        () =>
            (userType as unknown as UserType) === UserType.LiftOperator
                ? true
                : comparePermissions(
                      permissions as unknown as Permission[],
                      permissionsRequired
                  ),
        [userType, permissions, permissionsRequired]
    );

    const checkPermissions = useCallback(
        (permissionsNeeded: Permission[]) => {
            return comparePermissions(
                permissions as unknown as Permission[],
                permissionsNeeded
            );
        },
        [permissions]
    );

    return [
        isAuthorized,
        {
            checkPermissions,
        },
    ];
};
